export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_07.6d5212a4.jpg";